import { Box, InputProps, Input as NativeInput } from "@chakra-ui/react"
import { HTMLInputTypeAttribute, ReactNode } from "react";
import { SPACING } from "../generic/config";
import Text from "./Text";

const Input = ({
    title,
    defaultValue = "",
    type = "text",
    ...rest
}: {
    children?: ReactNode,
    title: string,
    type?: HTMLInputTypeAttribute,
    defaultValue?: string | number,
} & InputProps) => {

    return (
        <Box m={SPACING / 4} textAlign={"start"}>
            <Text weight="Bold" ml={SPACING / 2} mb={SPACING / 4}>
                {title}
            </Text>
            <NativeInput defaultValue={defaultValue} {...rest} type={type} style={{ ...rest.style }} />
        </Box>
    )
}

export default Input;